module.exports = "<div class=\"content content-deprecated\">\n    <div class=\"ui-screen\">\n        <div class=\"box w_100\">\n            <div class=\"paddedx2\">\n                <h2 class=\"alt\">\n                    {{'Please find the Privacy Policy in new window.' | translate }}\n                </h2>\n            </div>\n        </div>\n    </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/templates/merchantPrivacy.html
// module id = 344
// module chunks = 0